import { environmentService, userService, postRequestHandler, paginationRequestHandler} from "@/utils/services";
import { format } from 'date-fns';

let apiUrl = environmentService.apiUrlBooking;
let headers = {headers: userService.authHeader()};

export const bookingService = {
  getBookings,
  searchBookings,
  doNavigatePaginationBookings,
  editGuests,
  editObservation
};

async function doNavigatePaginationBookings (navigationHttpMethod, navigationParams) {
  return await paginationRequestHandler(navigationHttpMethod, navigationParams, headers);
}

async function getBookings () {
  var today = format(new Date(), 'yyyy-MM-dd');

  let bookingSearch = {
    clientIds: [],
    endDate: today,
    includeCancelledBookings: false,
    startDate: today,
    pagination: {
      page: 1,
      per_page: 50
    },
    sort: {
      field:'id',
      order:'desc'
    }

  };
  return searchBookings(bookingSearch);
}

async function searchBookings (bookingSearch) {
  return await postRequestHandler(`${apiUrl}/bookings`, bookingSearch, headers);
}

async function editGuests (guests){
  return await postRequestHandler(`${apiUrl}/bookings/update/guests`, guests, headers);
}

async function editObservation (observation){
  return await postRequestHandler(`${apiUrl}/bookings/update/observation`, observation, headers);
}



// WEBPACK FOOTER //
// ./src/utils/services/bookings/booking.service.js